export default __webpack_public_path__ + "1c0f88c4eb76284f78e7a42ab729cd84.png";